module.exports = __webpack_public_path__ + "img/share.cf2d2bb4.png";